module.exports = __webpack_public_path__ + "static/img/products discription_rooftop1.54bea96a.jpg";